
	// to replace jpg to gif in img
	function replaceGIF(){
		var mygif=document.getElementById('gif_to_jpg');
		mygif.src=mygif.getAttribute('data-jpg');
	}
	function replaceJPG(){
		var mygif = document.getElementById('gif_to_jpg');
		mygif.src = mygif.getAttribute('data-src');
	}
	
	
	$(document).ready(function() {
    	// used for FAQs on home page
    	$('.faqs_tabs_nav li:first-child').addClass('active');
    	$('.faqs_tab_data').hide();
    	$('.faqs_tab_data:first').show();
    	
    	$('.faqs_tabs_nav li').click(function(){
    		$('.faqs_tabs_nav li').removeClass('active');
    		$(this).addClass('active');
    		$('.faqs_tab_data').hide();
            
    		var activeTab = $(this).find('a').attr('href');
    		$(activeTab).fadeIn();
    		return false;
    	});
        
		$('.customer_question_part').on('click', function(e) {
			$(this).find('.faq_arrow').toggleClass('arrow_close arrow_close arrow_open');
			$(this).next('.customer_answere_part').slideToggle();
			$(this).toggleClass("customer_question_part customer_question_part active_question");// to hide/show faqs details.
		});
		
    	// used for tabs on pillowcase page
    	$('.size_tabs_nav li:first-child').addClass('active');
    	$('.size_tab_data').hide();
    	$('.size_tab_data:first').show();
    	
    	$('.size_tabs_nav li').click(function(){
    		$('.size_tabs_nav li').removeClass('active');
    		$(this).addClass('active');
    		$('.size_tab_data').hide();
            
    		var activeTab = $(this).find('.tab_link').data('href');
    		$(activeTab).fadeIn();
    		return false;
    	});
		
		$('.more_details_01_title').on('click', function() {
			$(this).find('.more_details_01_arrow').toggleClass('arrow_close arrow_close arrow_open');
			//$(this).closest('li').find('.more_details_01_content').toggleClass('closed');
			$(this).closest('li').find('.more_details_01_content').slideToggle();
		});
		
		$(".try_our_product").on('click', function() {
            var elmnt = document.getElementById("try_our_product");
            elmnt.scrollIntoView(); // ({behavior: 'smooth'})
            /*
			$('html,body').animate({
				scrollTop: $("#try_our_product").offset().top - 100
			}, '400');*/
		});
		
		$(".watch-video-01").on('click', function() {
			var video_01 = Wistia.api("qb6oaou4mf");
			video_01.popover.show(); 
			video_01.play(); // https://docs.wistia.com/docs/javascript-player-api#selective-autoplay-for-popovers

            // https://docs.wistia.com/docs/popover-embed-customization
            video_01.bind("popovershow", function() {
                console.log('---------------');
                replaceGIF();
            });
            video_01.bind("popoverhide", function() {
                console.log('-------xxxxxxx--------');
                replace_video_01_JPG2GIF();
            });
		});
		
	});
	
	
	$(function() {
		var reviewBlock = $('[data-review-carousel]');

		reviewBlock.each(function() {
			var self = $(this),
				reviewItems = self.find(".row"),
				itemShow	= self.data("item-to-show"),
				itemShowXS	= self.data("item-to-show-xs"),	//  520-xs
				itemShowSM	= self.data("item-to-show-sm"),	//  600-sm
				itemShowMD	= self.data("item-to-show-md"),	//  768-md
				itemShowLG	= self.data("item-to-show-lg"),	//  992-lg
				itemShowXL	= self.data("item-to-show-xl"), // 1200-xl

				itemDots	= self.data("item-dots"),
				itemDots_mb = self.data("item-dots-mb"),
				itemRow		= self.data("item-arrows"),
				itemRow_mb	= self.data("item-arrows-mb"),
				iconArrow	= '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';
          
                if(!itemShowSM) itemShowSM = itemShow;
                if(!itemShowMD) itemShowMD = itemShow;
                if(!itemShowLG) itemShowLG = itemShow;
                if(!itemShowXL) itemShowXL = itemShow;
                
			if (reviewItems.length > 0) {
				if (!reviewItems.hasClass('slick-initialized')) {
						reviewItems.slick({
							mobileFirst: true,
							adaptiveHeight: false,
							infinite: false,
							vertical: false,
							slidesToShow: 1,
							slidesToScroll: 1,	
							//fade: true, // no sliding
							dots: itemDots_mb,
							arrows: itemRow_mb,
							nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Slide Next">' + iconArrow + '</button>',
							prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Slide Prev">' + iconArrow + '</button>',
							responsive: [{
								breakpoint: 520,
									settings: {
										dots: itemDots_mb,
										arrows: itemRow_mb,
										slidesToShow: 1,
										slidesToScroll: 1,
									}
								},
								{
									breakpoint: 600,
									settings: {
										dots: itemDots,
										arrows: itemRow,
										slidesToShow: itemShowSM,
										slidesToScroll: 1,
									}
								},
								{
									breakpoint: 768,
									settings: {
										dots: itemDots,
										arrows: itemRow,
										slidesToShow: itemShowMD,
										slidesToScroll: 1,
									}
								},
								{
									breakpoint: 992,
									settings: {
										dots: itemDots,
										arrows: itemRow,
										slidesToShow: itemShowLG,
										slidesToScroll: 1,
									}
								},
								{
									breakpoint: 1200,
									settings: {
										dots: itemDots,
										arrows: itemRow,
										slidesToShow: itemShowXL,
										slidesToScroll: 1,
									}
								}
								
							]
						});
				}
			}

		});
	});
	
	
	$(function() {
    	// Pricing table - mobile only slider
    	var init = false;
    	var pricingCardSwiper;
    	var pricingLoanSwiper
    	function swiperCard() {
    		if (window.innerWidth <= 991.98) {
    			if (!init) {
    				init = true;
    				pricingCardSwiper = new Swiper("#pricingTableSlider", {
    					slidesPerView: "auto",
    					spaceBetween: 5,
    					grabCursor: true,
    					keyboard: true,
    					autoHeight: false,
    					navigation: {
    						nextEl: "#navBtnRight",
    						prevEl: "#navBtnLeft",
    					},
    				});
    			}
    		}
    		else if (init) {
    			pricingCardSwiper.destroy();
    			init = false;
    		}
    	}
    	swiperCard();
    	window.addEventListener("resize", swiperCard);
	});
